import React from 'react' 

import {
  Button,
  Image,
  Box,
} from "@chakra-ui/react";
import {ResgateProps} from '../dominio';
import { MainButton } from 'components/Button/MainButton';
import "../style.scss";
import { useNavigate } from "react-router-dom";
import Conteudo from 'components/Conteudo';

const Step3 = (props: any) => {
    const pageState: ResgateProps = props.pageState;
    const setPageState = props.setPageState;
    const navigate = useNavigate();

    return (
    <Box>
      <div className='resgate_process_content' style={{backgroundColor: 'rgb(3 155 86)', padding: '16px', width: '100%', color: '#ffffff'}}>Sucesso!</div>
      <div className='resgate_logo'>
        <Conteudo 
          tag='site-resgate-pix-sucesso' 
          tipo='banner' 
          element='Image' 
          alt="Resgate PIX" 
          className='resgate_logo_img'
        />
      </div>
      <div className='resgate_process_content' style={{fontSize: '18pt', fontWeight: '700', padding: '16px'}}>Resgate em andamento</div>
      <div className='resgate_process_content' style={{fontSize: '14pt', padding: '16px'}}>{pageState.mensagemSucesso}</div>
      <div className='resgate_process_panel_form'>
        <MainButton
            isLoading={false}
            onClick={() => navigate("/extrato-resgate")}
            width="292px"  
            fontSizeButton="20px"  
            title="Meus resgates"
        />
      </div>

    </Box>);
}

export default Step3